import { render } from "./Navigation.vue?vue&type=template&id=265e72ba&scoped=true"
import script from "./Navigation.vue?vue&type=script&setup=true&lang=js"
export * from "./Navigation.vue?vue&type=script&setup=true&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=265e72ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265e72ba"],['__file',"src/views/components/Navigation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "265e72ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('265e72ba', __exports__)) {
    api.reload('265e72ba', __exports__)
  }
  
  module.hot.accept("./Navigation.vue?vue&type=template&id=265e72ba&scoped=true", () => {
    api.rerender('265e72ba', render)
  })

}


export default __exports__